import React, { PropsWithChildren } from 'react'
import { Link as rrLink } from 'react-router-dom'
import styled from 'styled-components'

interface IProps {
  to: string
}

export const Link: React.FC<PropsWithChildren<IProps>> = ({ to, children }) => {
  return (
    <>
      <StyledLink to={to}>{children}</StyledLink>
    </>
  )
}

const StyledLink = styled(rrLink)`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`
